export const formatMoney = (num) => {
    // Adiciona o separador de milhar e o separador decimal
    // de acordo com o locale (região) do usuário
    const formatter = new Intl.NumberFormat('pt-BR', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
    });
    // Divide o número por 100 para transformá-lo em decimal
    const decimal = num / 100;
    // Formata o número decimal com separadores de milhar e decimal
    return formatter.format(decimal);
}